export const secondsToMs = (sec: number) => sec * 1000;

export const formatIsoDate = (v: unknown) => {
  if (!v) return null;
  const d = new Date(v as any);
  return Number.isFinite(d.getTime()) ? d.toISOString() : null;
};
